import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { Nullable, Object_Unknown } from "../../base-types";
import Link from "../../link";

@JsonObject()
export class DistributeNotificationResource {
    @JsonProperty("channels")
    @JsonElementType(String)
    channels: Array<string>;

    @JsonProperty("recipients")
    @JsonElementType(Link)
    recipients: Nullable<Array<Link>>;

    @JsonProperty("parameters")
    parameters: Object_Unknown;
}
